$.fn.removeClassPrefix = function (prefix) {
  this.each((i, it) => {
    const classes = it.className.split(" ").map(item => (item.indexOf(prefix) === 0 ? "" : item));
    it.className = $.trim(classes.join(" "));
  });

  return this;
};
